import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container';
import { GetLicense, GetHardwareByHardwareKey, listLicenseLinks } from '../../services/service'
import dateFnsFormat from 'date-fns/format';
import { parseDurationVerbose, handleDownloadLicense, } from '../../services/utils';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Typography } from '@mui/material';
import { FaExternalLinkAlt, FaFileDownload } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { blue } from '@material-ui/core/colors/';



const ColorButton = styled(Button)(({ theme }) => ({
    color: 'white',
    backgroundColor: blue[700],
    '&:hover': {
        backgroundColor: blue[900],
    },
}));


export default function LicenseDetail() {
    const params = useParams()
    const [licenseData, setLicenseData] = useState({})
    const [hardwareData, setHardwareData] = useState({})
    const [listLicenseLinksData, setListLicenseLinksData] = useState([])
    const [notFound, setNotFound] = useState(false)

    const licenseTypeMap = {
        historian: "Historian",
        pid: "PID",
        anomaly: "Anomaly",
        forecast: "Forecast",
    }

    const licenseTypeParser = (types) => {
        var verboseNameArray = types.map(el => licenseTypeMap[el])
        var verboseTypes = ""
        if (verboseNameArray.length === 3) {
            verboseTypes = verboseNameArray.join(" & ")
        } else if (verboseNameArray.length >= 4) {
            var arr1 = verboseNameArray.slice(0, 3).join(", ")
            var arr2 = verboseNameArray.slice(-1)
            verboseTypes = [arr1, arr2].join(" & ")
        } else {
            verboseTypes = verboseNameArray[0]
        }
        return verboseTypes
    }

    useEffect(() => {
        GetLicense(params.id).then(async (response) => {
            response.data.license_type["duration_verbose"] = parseDurationVerbose(response.data.license_type.duration)
            response.data["expiration_datetime"] = dateFnsFormat(new Date(response.data.expiration_datetime), 'MMMM d, yyyy - HH:mm')
            response.data["created_at"] = dateFnsFormat(new Date(response.data.created_at), 'MMMM d, yyyy - HH:mm')
            setLicenseData(response.data)

            GetHardwareByHardwareKey(response.data.hardware_key).then((response) => {
                setHardwareData(response.data)
                var filters = {}
                filters["hardware_keys"] = response.data.hardware_key
                listLicenseLinks(1, 1, filters).then((response) => {
                    setListLicenseLinksData(response.data.results[0])
                })
            }).catch((err) => {
                console.log(err.response)
            })
        }).catch((err) => {
            console.log(err)
            if (err.response.status === 404) {
                setNotFound(true)
            }
        })
    }, [])

    const CardLicense = (props) => {
        const { title, content, description } = props;
        const contentAsText = !!description ? "body1" : "h5"
        return (
            <Card sx={{ display: 'flex', backgroundColor: "#E7EBF0", boxShadow: "0 8px 20px -12px rgba(0,0,0,0.3)", }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography variant="subtitle1" color="text.secondary" component="div">
                            {title}
                        </Typography>
                        <Typography component="div" variant={contentAsText} sx={{ whiteSpace: 'pre-line' }}>
                            {content}
                        </Typography>
                    </CardContent>
                </Box>
            </Card>
        )
    }

    return (
        !!notFound
            ? (
                <Typography variant={"h4"}>
                    {"Not Found"}
                </Typography>
            )
            : (
                licenseData.company === undefined
                    ? null
                    : (
                        <Container>
                            <Row style={{ padding: "20px" }}>
                                <Typography align="center" component="div" variant="h4">
                                    Licença
                                </Typography>
                            </Row>
                            <Row>
                                <Col lg={6}>
                                    <CardLicense
                                        title={"Data de Criação"}
                                        content={licenseData.created_at}
                                    />
                                </Col>
                                <Col lg={6}>
                                    <CardLicense
                                        title={"Data de Expiração"}
                                        content={licenseData.expiration_datetime}
                                    />
                                </Col>
                            </Row>
                            <Row style={{ padding: "20px 0px 20px 0px" }}>
                                <Col lg={12}>
                                    <CardLicense
                                        title={"Descrição da Licença"}
                                        content={licenseData.description}
                                        description={true}
                                    />
                                </Col>
                            </Row>
                            {
                                !!licenseData.is_linked
                                    ? <Row style={{ justifyContent: "center" }}>
                                        <ColorButton
                                            sx={{ padding: 2, width: "40%" }}
                                            startIcon={<FaFileDownload />}
                                            onClick={() => handleDownloadLicense(listLicenseLinksData)}>
                                            Download dos Arquivos da Licença (.zip)
                                        </ColorButton>
                                    </Row>
                                    : null
                            }
                            {
                                !!licenseData.license_type
                                    ? (
                                        <>
                                            <Row style={{ padding: "20px" }}>
                                                <Typography align="center" component="div" variant="h4">
                                                    Informações sobre o Modelo de Licença <strong>{licenseData.license_type.name}</strong>
                                                </Typography>
                                            </Row>
                                            <Row>
                                                <Col lg={6}>
                                                    <CardLicense
                                                        title={"Tipo de Licença"}
                                                        content={licenseTypeParser(licenseData.license_type.types)}
                                                    />
                                                </Col>
                                                <Col lg={6}>
                                                    <CardLicense
                                                        title={"Duração"}
                                                        content={licenseData.license_type.duration_verbose}
                                                    />
                                                </Col>
                                            </Row>
                                                {
                                                    !!licenseData.license_type.config
                                                        ?
                                                        <>
                                                        <Row style={{ padding: "20px 0px 20px 0px" }}>
                                                            <Col lg={6}>
                                                                <CardLicense
                                                                    title={"Máximo de Tags"}
                                                                    content={
                                                                        !licenseData.license_type.config.historian
                                                                            ? "N/A"
                                                                            : !!licenseData.license_type.config.historian.max_tags
                                                                                ? licenseData.license_type.config.historian.max_tags
                                                                                : "∞"

                                                                    }
                                                                />
                                                            </Col>
                                                            <Col lg={6}>
                                                                <CardLicense
                                                                    title={"Máximo de Malhas de Controle"}
                                                                    content={
                                                                        !licenseData.license_type.config.pid
                                                                            ? "N/A"
                                                                            : !!licenseData.license_type.config.pid.max_control_loops
                                                                                ? licenseData.license_type.config.pid.max_control_loops
                                                                                : "∞"

                                                                    }
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>

                                                            <Col lg={6}>
                                                                <CardLicense
                                                                    title={"Máximo de Anomalias"}
                                                                    content={
                                                                        !licenseData.license_type.config.anomaly
                                                                        ? "N/A"
                                                                            : !!licenseData.license_type.config
                                                                                ? licenseData.license_type.config.anomaly.max_anomalies
                                                                                : "∞"

                                                                            }
                                                                            />
                                                            </Col>
                                                            <Col lg={6}>
                                                                <CardLicense
                                                                    title={"Máximo de Forecasts"}
                                                                    content={
                                                                        !licenseData.license_type.config.forecast
                                                                        ? "N/A"
                                                                        : !!licenseData.license_type.config
                                                                                ? licenseData.license_type.config.forecast.max_forecasts
                                                                                : "∞"
                                                                                
                                                                            }
                                                                            />
                                                            </Col>
                                                        </Row>
                                                    </>
                                                    : null
                                            }
                                            <Row style={{ padding: "20px 0px 20px 0px" }}>
                                                <Col lg={12}>
                                                    <CardLicense
                                                        title={"Descrição do Modelo de Licença"}
                                                        content={licenseData.license_type.description}
                                                        description={true}
                                                    />
                                                </Col>
                                            </Row>
                                        </>)
                                    : null
                            }
                            {
                                licenseData.is_linked
                                    ? (
                                        <>
                                            <Row style={{ padding: "30px 20px 20px 20px" }}>
                                                <Typography align="center" component="div" variant="h5">
                                                    Hardware Vinculado <Link to={`/hardware/${hardwareData.id}`} target="_blank" rel="noopener noreferrer"><FaExternalLinkAlt /></Link>
                                                </Typography>
                                            </Row>
                                            <Row>
                                                <Col lg={6}>
                                                    <CardLicense
                                                        title={"Nome do Hardware"}
                                                        content={hardwareData.name}
                                                    />
                                                </Col>
                                                <Col lg={6}>
                                                    <CardLicense
                                                        title={"Chave do Hardware"}
                                                        content={hardwareData.hardware_key}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row style={{ padding: "20px 0px 20px 0px" }}>
                                                <Col lg={12}>
                                                    <CardLicense
                                                        title={"Descrição do Hardware"}
                                                        content={hardwareData.description}
                                                        description={true}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row style={{ padding: "20px", justifyContent: "center" }}>
                                            </Row>
                                        </>
                                    )
                                    : null
                            }
                        </Container>
                    )
            )
    );
}